import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  allArbitrators,
  allMediators,
  boardsAndPanelEmpanelMembershipStatus,
  boardsAndPanelEmpanelmentFetchDocument,
  boardsAndPanelEmpanelmentPersonalDetails,
  boardsAndPanelEmpanelmentProfessionalDetails,
  boardsAndPanelEmpanelmentProfessionalRegistration,
  boardsAndPanelEmpanelmentRegistrationDocumentView,
  boardsAndPanelEmpanelmentRegistrationReviewAndApproval,
  boardsAndPanelEmpanelmentRegistrationView,
  boardsAndPanelEmpanelmentRegReOpen,
  boardsAndPanelMediatorReviewAndApproval,
  boardsAndPanelMediatorsEmpanelmentRegReOpen,
  boardsAndPanelMediatorsStatus,
} from "../../../api/boardsAndPanel_api";

export const allArbitratorsAction = createAsyncThunk(
  "BoardsAndPanel/allArbitrators",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await allArbitrators();
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const boardsAndPanelEmpanelmentRegistrationViewAction = createAsyncThunk(
  "BoardsAndPanel/boardsAndPanelEmpanelmentRegistrationView",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await boardsAndPanelEmpanelmentRegistrationView(values);
      return result.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const boardsAndPanelEmpanelmentRegistrationDocumentViewAction =
  createAsyncThunk(
    "BoardsAndPanel/boardsAndPanelEmpanelmentRegistrationDocumentView",
    async (values, { rejectWithValue, getState }) => {
      try {
        const result =
          await boardsAndPanelEmpanelmentRegistrationDocumentView(values);

        if (result.payload && result.payload instanceof Blob) {
          const objectUrl = URL.createObjectURL(result.payload);

          return {
            objectUrl,
            fileName: values,
            contentType:
              result.headers?.["content-type"] || "application/octet-stream",
            status: result.status || 200,
          };
        }

        return result;
      } catch (error) {
        return rejectWithValue(error.message || "something went wrong");
      }
    }
  );

export const boardsAndPanelEmpanelmentFetchDocumentAction = createAsyncThunk(
  "BoardsAndPanel/boardsAndPanelEmpanelmentFetchDocument",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await boardsAndPanelEmpanelmentFetchDocument(values);
      return result.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

//Prof Reg

export const boardsAndPanelEmpanelmentProfessionalRegistrationAction =
  createAsyncThunk(
    "BoardsAndPanel/professionalRegistration",
    async (values, { rejectWithValue }) => {
      try {
        const result =
          await boardsAndPanelEmpanelmentProfessionalRegistration(values);

        return result?.data?.data ?? [];
      } catch (error) {
        return rejectWithValue(error.message || "something went wrong");
      }
    }
  );

//Personal Reg

export const boardsAndPanelEmpanelmentPersonalDetailsAction = createAsyncThunk(
  "BoardsAndPanel/PersonalDetails",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await boardsAndPanelEmpanelmentPersonalDetails(values);

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

//prof details

export const boardsAndPanelEmpanelmentProfessionalDetailsAction =
  createAsyncThunk(
    "BoardsAndPanel/professionalDetails",
    async (values, { rejectWithValue, getState }) => {
      try {
        const result =
          await boardsAndPanelEmpanelmentProfessionalDetails(values);

        return result?.data?.data ?? [];
      } catch (error) {
        return rejectWithValue(error.message || "something went wrong");
      }
    }
  );

export const boardsAndPanelEmpanelmentRegistrationReviewAndApprovalAction =
  createAsyncThunk(
    "BoardsAndPanel/reviewAndApprovalAction",
    async (values, { rejectWithValue, getState }) => {
      try {
        const result =
          await boardsAndPanelEmpanelmentRegistrationReviewAndApproval(values);

        return result?.data ?? [];
      } catch (error) {
        return rejectWithValue(error.message || "something went wrong");
      }
    }
  );

export const boardsAndPanelBoardsAndPanelEmpanelmentRegReOpenAction =
  createAsyncThunk(
    "BoardsAndPanel/empanelmentRegReOpen",
    async (values, { rejectWithValue, getState }) => {
      try {
        const result = await boardsAndPanelEmpanelmentRegReOpen(values);

        return result?.data ?? [];
      } catch (error) {
        return rejectWithValue(error.message || "something went wrong");
      }
    }
  );

export const boardsAndPanelEmpanelMembershipStatusAction = createAsyncThunk(
  "BoardsAndPanel/empanelMembershipStatus",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await boardsAndPanelEmpanelMembershipStatus(values);

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

// Mediator Action

export const allMediatorsAction = createAsyncThunk(
  "BoardsAndPanel/allMediators",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await allMediators();
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const boardsAndPanelMediatorReviewAndApprovalAction = createAsyncThunk(
  "BoardsAndPanel/mediatorReviewAndApproval",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await boardsAndPanelMediatorReviewAndApproval(values);

      return result?.data ?? [];
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const boardsAndPanelMediatorsEmpanelmentRegReOpenAction =
  createAsyncThunk(
    "BoardsAndPanel/empanelmentRegReOpen",
    async (values, { rejectWithValue, getState }) => {
      try {
        const result =
          await boardsAndPanelMediatorsEmpanelmentRegReOpen(values);

        return result?.data ?? [];
      } catch (error) {
        return rejectWithValue(error.message || "something went wrong");
      }
    }
  );

export const boardsAndPanelMediatorsStatusAction = createAsyncThunk(
  "BoardsAndPanel/mediatorsStatus",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await boardsAndPanelMediatorsStatus(values);

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);
